/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum EEfsBackupTypes {
    Backup = 0,
    BackupCopy = 1,
}
